import {put, call, takeLatest, debounce, select} from 'redux-saga/effects';
import creditTermsApi from '../api/creditTerms.api';
import * as ActionTypes from '../actions/types.action';
import {getBearerHeader} from '../helpers/api.helper';
import {OUTCOME_MESSAGE_CODES} from '../constants/constants';

function* applyForCredit(action) {
  try {
    const storeToken = yield select(state => state.auth);
    const headers = getBearerHeader(null, storeToken);
    if (!headers) {
      yield put({type: ActionTypes.ERROR_REQUIRE_LOGIN});
      return;
    }

    const result = yield call(
      creditTermsApi.applyForCredit,
      action.data,
      headers
    );
    yield put({
      type: ActionTypes.APPLY_FOR_CREDIT_SUCCESS,
      outcome:
        result && result.outcome
          ? result.outcome
          : OUTCOME_MESSAGE_CODES.REFERRED,
      responseWorkingDays: result && result.responseWorkingDays,
    });
  } catch (e) {
    // Prefer credit-check-svc's `{error: "..."}` body (e.g. a validation
    // message) over axios's generic "Request failed with status code 4xx".
    const message =
      (e.response && e.response.data && e.response.data.error) || null;
    yield put({type: ActionTypes.APPLY_FOR_CREDIT_FAILED, message});
  }
}

function* lookupCompany(action) {
  try {
    const storeToken = yield select(state => state.auth);
    const headers = getBearerHeader(null, storeToken);
    if (!headers) {
      yield put({type: ActionTypes.ERROR_REQUIRE_LOGIN});
      return;
    }

    const result = yield call(
      creditTermsApi.lookupCompany,
      action.companiesHouseNumber,
      headers
    );
    yield put({type: ActionTypes.LOOKUP_COMPANY_SUCCESS, company: result});
  } catch (e) {
    // A 404 simply means no company matched that number — a normal, expected
    // state, not an error the user needs to be alarmed by.
    if (e.response && e.response.status === 404) {
      yield put({type: ActionTypes.LOOKUP_COMPANY_NOT_FOUND});
      return;
    }
    const message =
      (e.response && e.response.data && e.response.data.error) || null;
    yield put({type: ActionTypes.LOOKUP_COMPANY_FAILED, message});
  }
}

export default function* creditTermsSaga() {
  yield takeLatest(ActionTypes.APPLY_FOR_CREDIT_REQUESTED, applyForCredit);
  // Debounce keystroke-driven lookups so we don't hit Companies House on every
  // character (and stay well within its rate limit).
  yield debounce(400, ActionTypes.LOOKUP_COMPANY_REQUESTED, lookupCompany);
}
